import { get, post} from 'mdoc/admin/axios/tools'
import * as config from 'mdoc/admin/axios/config'


// 管理员登录获取
export const login = (param) => post(config.ADMIN_LOGIN, param)

//before login
export const dictionary_before_login = (param) => new Promise((resolve, reject)=> {
    get(config.DICTIONARY_BEFORE_LOGIN,{...param,'typeFlg':0})
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response.docMstLanguage)
            }
        }).catch(function (error) {
        reject(error);
    })
})


//找回密码发送邮件
export const forgetPswSendEmail = (param,lang) => new Promise((resolve, reject)=> {
    post(config.SENT_PSW_EMAIL, {...param,lang:lang})
        .then(function (response) {
            if (response.error) {
                if(response.errorCode === 'E201'){
                    reject(response.errorMessage);
                }else{
                    reject(response.errorMessage);
                }
            }else {
                resolve({results: response})
            }
        }).catch(function (error) {
        reject(error);
    })
})